module.exports = __webpack_public_path__ + "img/eye-solid.16b02358.svg";